import { Component, OnInit} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { routerTransition } from '../_animations/index';
import * as THREE from 'three-full';
// import {  Editor3DModule } from 'ng2-3d-editor';

// declare var THREE : any;
declare var renderer : THREE.WebGLRenderer;
declare var camera : THREE.PerspectiveCamera;
declare var scene : THREE.Scene;

@Component({
  selector: 'app-hplcselect',
  templateUrl: './hplcselect.component.html',
  styleUrls: ['./hplcselect.component.css'],
  animations: [routerTransition],
  host: { '[@routerTransition]': '' }
})
export class HplcselectComponent implements OnInit {

  // scene = new THREE.Scene();
  // camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
  // geometry = new THREE.BoxGeometry( 200, 200, 200 );
  // material = new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: true } );
  // mesh = new THREE.Mesh( this.geometry, this.material );
  // renderer = new THREE.WebGLRenderer();
  //
  // mycanvas = document.getElementById("canvas");
  //
  // i=0;

  // camera.position.z = 1000;
  // scene.add( this.mesh );
  // renderer.setSize( window.innerWidth, window.innerHeight );
  // document.body.appendChild( renderer.domElement );

//   animate = function animate() {
//     // this.i++;
//     console.log(this.i);
//     requestAnimationFrame( animate );
//     this.mesh.rotation.x += 0.01;
//     this.mesh.rotation.y += 0.02;
//     renderer.render( scene, camera );
// }


  getState(outlet) {
    console.log(outlet.activatedRouteData.state);
      return outlet.activatedRouteData.state;
    }
  constructor() {

  //   this.camera.position.z = 1000;
  //   this.mesh.id=55;
  //   this.scene.add( this.mesh );
  //   renderer.setSize( window.innerWidth, window.innerHeight );
  //   this.mycanvas.appendChild( renderer.domElement );
  //
  //   var animate = function () {
  //     // this.i++;
  //     console.log(this.i);
  //     requestAnimationFrame( animate );
  //     scene.getObjectById(55).rotation.x += 0.01;
  //     scene.getObjectById(55).rotation.y += 0.02;
  //     renderer.render( scene, camera );
  // }
  //
  //   animate();
  }

  ngOnInit() {
  }

}
